export enum View {
    LOGIN,
    SIGN_UP,
    RESET_PASSWORD,
    ADD_CARD,
    CARDS_ON_FILE,
}
